import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";

import { Panel } from "primereact/panel";

import Server from "./../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { confirmAlert } from "react-confirm-alert";
import { AutoComplete } from "primereact/autocomplete";
import { Chip } from "primereact/chip";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { Toast } from "primereact/toast";

class SetNotification extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetNotif = this.SetNotif.bind(this);

    this.state = {
      layout: "list",
      name: "",
      ShopsList: [],
      type: "1",
      FId: "",
      DbTableName: "",
      usersList: [],
      DBTableField: "",
      latinName: "",
    };
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0,
      });
      that.getNotificationList();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  SetNotif() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      title: this.state.title,
      body: this.state.body,
    };
    this.setState({
      HasErrorForMaps: null,
      loading: 1,
    });
    let SCallBack = function (response) {
      that.onHideFormsDialog();
      that.getNotificationList();
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
    };
    this.Server.send("AdminApi/setNotification", param, SCallBack, ECallBack);
  }
  CreateForm() {
    this.setState({
      visibleManageField: true,
      title: "",
      enable: true,
      body: "",
      usersList: [],
      selectedId: null,
    });
  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null,
    });
  }
  selectedComponentChange(value) {
    let that = this;
    var p = [];
    this.setState({
      title: value.title,
      body: value.body,
      usersList: value.usersList,
      selectedId: value._id,
      visibleManageField: true,
    });
  }
  getNotificationList() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        GridDataFields: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send(
      "AdminApi/getNotificationList",
      param,
      SCallBack,
      ECallBack
    );
  }
  onSelect(event) {
    let List = this.state.usersList.filter((e) => e.remove != "1");
    List.push({
      title: event.value.name,
      username: event.value.username,
    });
    var flags = [],
      output = [],
      l = List.length,
      i;
    for (i = 0; i < l; i++) {
      if (flags[List[i].title]) continue;
      flags[List[i].title] = true;
      output.push(List[i]);
    }

    this.setState({
      searchName: event.value.name,
      searchId: event.value.username,
      usersList: output,
    });
  }
  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {};
    param = {
      title: event.query,
      table: "users",
      name: ["name", "username", "RaymandAcc", "RaymandUser"],
    };

    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({
          _id: v._id,
          name: v.name,
          username: v.username,
        });
      });
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {};
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack);
  }
  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          username={brand.username}
        >
          <div
            className="col-8"
            username={brand.username}
            style={{ textAlign: "right" }}
          >
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              username={brand.username}
            >
              <span
                style={{ whiteSpace: "pre-wrap" }}
                username={brand.username}
              >
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={this.SetNotif}
          style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );
    return (
      <div style={{ direction: "rtl" }}>
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center mt-2">
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="لیست پیغام ها"
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <div className="row">
                <div className="col-6" style={{ textAlign: "right" }}>
                  <button
                    className="btn btn-primary irsans"
                    onClick={this.CreateForm}
                    style={{
                      width: "200px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    ایجاد پیغام جدید
                  </button>
                </div>
              </div>
              <DataTable
                responsive
                value={this.state.GridDataFields}
                selectionMode="single"
                selection={this.state.selectedComponent}
                onSelectionChange={(e) => this.selectedComponentChange(e.value)}
              >
                <Column
                  field="title"
                  header="عنوان"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="body"
                  header="متن"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="date"
                  header="تاریخ ارسال"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="time"
                  header="ساعت ارسال"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
          </div>
        </div>

        <Dialog
          header={this.state.selectedId ? "مشاهده" : "ساخت پیغام جدید"}
          visible={this.state.visibleManageField}
          footer={footer}
          minY={70}
          style={{ width: "700px" }}
          onHide={this.onHideFormsDialog}
          maximizable={false}
        >
          <form>
            <div className="row" style={{ alignItems: "baseline" }}>
              <div className="col-lg-6">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    disabled={this.state.selectedId}
                    value={this.state.title}
                    name="title"
                    onChange={(event) =>
                      this.setState({ title: event.target.value })
                    }
                    required="true"
                  />
                  <label>عنوان</label>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    disabled={this.state.selectedId}
                    value={this.state.body}
                    name="body"
                    onChange={(event) =>
                      this.setState({ body: event.target.value })
                    }
                    required="true"
                  />
                  <label>متن</label>
                </div>
              </div>

              <div className="col-lg-12" style={{ display: "none" }}>
                <div className="group">
                  <AutoComplete
                    disabled={this.state.all}
                    placeholder="بخشی از نام / شماره موبایل / شناسه کاربری / شماره حساب  را وارد کنید"
                    style={{ width: "100%" }}
                    onChange={(event) => {
                      this.setState({ searchName: event.value });
                    }}
                    itemTemplate={this.itemTemplate.bind(this)}
                    value={this.state.searchName}
                    onSelect={(e) => this.onSelect(e)}
                    suggestions={this.state.brandSuggestions}
                    completeMethod={this.suggestBrands.bind(this)}
                  />
                  <div
                    style={{
                      marginTop: 10,
                      textAlign: "right",
                      marginBottom: 10,
                    }}
                  >
                    {typeof this.state.usersList == "object" &&
                      this.state.usersList.map((v, i) => {
                        if ((v.title || v.username) && !v.remove) {
                          return (
                            <Chip
                              label={v.title || v.username}
                              _id={v._id}
                              style={{ marginLeft: 5 }}
                              removable={true}
                              onRemove={(event) => {
                                let title =
                                  event.target.parentElement.getElementsByClassName(
                                    "p-chip-text"
                                  )[0].textContent;
                                let List = this.state.usersList;
                                for (let i = 0; i < List.length; i++) {
                                  if (
                                    List[i].title == title ||
                                    List[i].username == title
                                  ) {
                                    List[i].remove = 1;
                                  }
                                }
                              }}
                            />
                          );
                        }
                      })}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(SetNotification);
